"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(require("./lib/index"));



//////////////////
// WEBPACK FOOTER
// ./src/index.ts
// module id = 8
// module chunks = 0 1